import { Grid, Space } from "../../Layout";
import { Texts, Title, Media } from "../../Object";

const Head = (props) => {
  const type = props.type;

  let mediaCheck = false;
  if (type === "noimage") {
    mediaCheck = false;
  } else {
    mediaCheck = true;
  }

  return (
    <>
      <div className="p-page__wrap" data-state={type}>
        <div className="l-row" data-state="right">
          <div className="p-page__wrap--inner" data-state={props.type}>
            <Title slug={props.slug} type="white"></Title>
            {mediaCheck && (
              <Media
                class="p-page__img--head"
                src={`page-head/${props.slug}`}
                alt="Hero media"
              ></Media>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Head;
